// LogoutTrigger — fires logout on mount then redirects to /login.

import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { useAuthStore } from '../../store/authStore';

export function LogoutTrigger() {
  const { logout } = useAuth();
  const status = useAuthStore((s) => s.status);

  useEffect(() => {
    void logout();
  }, [logout]);

  if (status === 'anonymous') {
    return <Navigate to="/login" replace />;
  }
  return null;
}
